import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import { createPath, ROUTE } from "app-constants/routing"
import InfiniteHorizontalScroller from "components/InfiniteHorizontalScroller"
import SmallVideoCard from "components/videos/SmallVideoCard"
import { UseMoreParams } from "models/convention-api/types"
import ConventionVideo from "models/convention-api/v1/ConventionVideo"
import React, { useMemo, useState } from "react"

const useStyles = makeStyles()(
  (theme) => ({
    rootContainer: {
      width: "100%",
    },
    smallVideoCardContainer: {
      marginRight: theme.spacing(2),
      display: "flex",
      width: 280,
    },
  }),
)

interface VideosInfiniteHorizontalScrollerProps {
  pagesParams: UseMoreParams | (() => UseMoreParams)
  title: string
  emptyStateMessage: string
}

// TODO: Need to be refactored
/*
This will be deleted or simplified after improving reusability of InfiniteHorizontalScroller
or creating a new component for this that will be much generic than InfiniteHorizontalScroller
 */
export const VideosInfiniteHorizontalScroller = (props: VideosInfiniteHorizontalScrollerProps) => {
  const { pagesParams, title, emptyStateMessage } = props
  const normalizedPagesParams = useMemo(
    () => (typeof pagesParams === "function" ? pagesParams() : pagesParams),
    [pagesParams],
  )
  const { classes } = useStyles()

  const [isLoading, setIsLoading] = useState(false)

  const videos = ConventionVideo.useMore(normalizedPagesParams)
  const loadMore = async () => {
    setIsLoading(true)
    await videos.loadMore()
    setIsLoading(false)
  }

  return (
    <Box className={classes.rootContainer}>
      <InfiniteHorizontalScroller
        title={title}
        emptyStateMessage={emptyStateMessage}
        hasMore={videos.hasMore}
        loadMore={loadMore}
        loading={
          (isLoading || videos.isLoading) &&
          normalizedPagesParams.fallbackData?.length === normalizedPagesParams.limit
        }>
        {videos.data?.map((video) => (
          <Box className={classes.smallVideoCardContainer} key={video.id}>
            <SmallVideoCard
              href={createPath({ path: ROUTE.VIDEO, params: { videoId: video.id } })}
              imageSrc={video.thumbnail_url ?? ""}
              imageAlt=""
              curatorName={video.institution?.name ?? ""}
              title={video.name}
              numberOfViews={video.video_count?.video_count ?? 0}
            />
          </Box>
        ))}
      </InfiniteHorizontalScroller>
    </Box>
  )
}
